import React, {Component} from "react";
import PropTypes from "prop-types";
import {Card} from "react-bootstrap";
import AscModal from "../Elements/Modal/Modal";
import {ViewDeleteVocCategoryList} from "../Elements/AscElements/VocCategoryElements";

export default class VocCategoryDeleteModal extends Component {
    render() {
        return (
            <AscModal
                state={this.props.state}
                propSetState={this.props.propSetState}
                langText={this.props.langText}
                validationHandle={this.props.validationHandle}
                onClick={this.props.onClick}>
                <Card variant="info">
                    <Card.Body>
                        <ViewDeleteVocCategoryList
                            state={this.props.state}
                            langText={this.props.langText}
                        />
                    </Card.Body>
                </Card>
            </AscModal>
        );
    }
}

VocCategoryDeleteModal.propTypes = {
    state: PropTypes.object.isRequired,
    langText: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
    validationHandle: PropTypes.func.isRequired,
    propSetState: PropTypes.func,
};
